import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import { UserProfileData } from "../../FetchAPI";
// import { Link } from "react-router-dom";
import DeshBoardFooter from "../DeshBoardFooter";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { useAuth } from "../../../Store/AuthContext";
import "./profileEdit.css";
import { Helmet } from "react-helmet";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
// import NotifyMessage from "../../Others/NotifyMessage";
// import APIDataFetchLoader from "../../Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function AccountDetailsUpdate() {
  const { userID, RendomTokenfetch, userRoll } = useAuth();

  const location = useLocation();
  const returnTo = location.state?.returnTo || "/account-details-update"; // fallback to self

  const [ProfileuserData] = UserProfileData(RendomTokenfetch);
  // console.log(ProfileuserData);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  // Refs for all input
  const bankname = useRef(ProfileuserData?.bank_name || "");
  const accHoldername = useRef(ProfileuserData?.account_holder || "");
  const [AccNumber, setAccNumber] = useState("");
  const [ifscCode, setifscCode] = useState("");
  const [upiId, setUpiID] = useState("");

  useEffect(() => {
    if (ProfileuserData) {
      setAccNumber(ProfileuserData?.account_number || "");
      setifscCode(ProfileuserData?.ifsc_code || "");
      setUpiID(ProfileuserData?.upiId || "");
    }
  }, [ProfileuserData]);

  // const handleKeyPress = (e) => {
  //   const charCode = e.which || e.keyCode;
  //   if (charCode < 48 || charCode > 57) {
  //     e.preventDefault();
  //   }
  // };

  const handleAccNumber = (e) => {
    const value = e.target.value;
    if (value.length <= 20) {
      setAccNumber(value);
    }
  };

  const [OnErrors, setOnErrors] = useState({ pan: "", ifsc: "" });

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const upiRegex = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;

  const handleifscCode = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    setifscCode(value);
    if (value === "") {
      setOnErrors((prev) => ({ ...prev, ifsc: "" }));
    } else if (!ifscRegex.test(value)) {
      setOnErrors((prev) => ({
        ...prev,
        ifsc: "Invalid IFSC format (ABCD0123456)",
      }));
    } else {
      setOnErrors((prev) => ({ ...prev, ifsc: "" }));
    }
  };

  const handleUpiID = (e) => {
    const value = e.target.value.trim(); // space remove
    setUpiID(value);

    if (value === "") {
      setOnErrors((prev) => ({ ...prev, upi: "" }));
    } else if (!upiRegex.test(value)) {
      setOnErrors((prev) => ({
        ...prev,
        upi: "Invalid UPI format (example: name@bank)",
      }));
    } else {
      setOnErrors((prev) => ({ ...prev, upi: "" }));
    }
  };

  const preventSpaceAndEnter = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
    ];

    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
    } else if (
      !/^[a-zA-Z0-9@._-]$/.test(e.key) &&
      !allowedKeys.includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  // Handle On Form Submit
  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("userRoll", userRoll);
    fdata.append("bank_name", bankname.current?.value || "");
    fdata.append("account_holder", accHoldername.current?.value || "");
    fdata.append("account_number", AccNumber);
    fdata.append("ifsc_code", ifscCode);
    fdata.append("upiId", upiId);
    if (
      bankname.current.value &&
      accHoldername.current.value &&
      AccNumber &&
      ifscCode
    ) {
      try {
        setLoading(true);
        axios
          .post(`${WebsiteAPIurl}account_details_edit`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            // console.log(response.data);

            if (response.data.Status === "1") {
              NotifyMessageNoReload(response.data.msg, "success", true);
              navigate(returnTo);
            } else {
              NotifyMessageNoReload(response.data.msg, "danger");
            }
          });
      } catch (error) {
        alert(error);
      } finally {
        setLoading(false);
      }
    } else {
      NotifyMessageNoReload("Please Fill All Feilds ! ", "danger");
    }
  };

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  // if (profLoading) {
  //   return <APIDataFetchLoader />;
  // }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "My Profile", pagelink: "profile" },
            { name: "Account Details Update" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content py-4">
                      <form
                        onSubmit={handleSubmit}
                        encType="multipart/form-data"
                        className="was-validated"
                      >
                        <div className="row">
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label className="form-label" htmlFor="name">
                              Bank Name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="bankname"
                              ref={bankname}
                              defaultValue={ProfileuserData?.bank_name || ""}
                              className="form-control"
                              required
                            />
                          </div>
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label className="form-label" htmlFor="name">
                              Name of Account Holder
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="accHoldername"
                              ref={accHoldername}
                              defaultValue={
                                ProfileuserData?.account_holder || ""
                              }
                              className="form-control"
                              required
                            />
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              Account Number
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="AccNumber"
                              onChange={handleAccNumber}
                              // onKeyPress={handleKeyPress}
                              value={AccNumber}
                              maxLength={20}
                              // inputMode="numeric"
                              required
                              className="form-control"
                            />
                          </div>

                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              IFSC Code<span className="text-danger">*</span>
                            </label>
                            <div className="input-group ">
                              <input
                                type="text"
                                className="form-control"
                                onChange={handleifscCode}
                                onKeyDown={preventSpaceAndEnter}
                                value={ifscCode}
                                maxLength={11}
                                inputMode="text"
                                required
                                placeholder="Enter IFSC (ABCD0123456)"
                              />
                            </div>
                            {OnErrors.ifsc && (
                              <span
                                style={{ color: "#db1212", fontSize: "13px" }}
                              >
                                {OnErrors.ifsc}
                              </span>
                            )}
                          </div>

                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              UPI ID<span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="upiid"
                                onChange={handleUpiID}
                                onKeyDown={preventSpaceAndEnter}
                                value={upiId}
                                inputMode="text"
                                placeholder="example@bank"
                              />
                            </div>
                            {OnErrors.upi && (
                              <span
                                style={{ color: "#db1212", fontSize: "13px" }}
                              >
                                {OnErrors.upi}
                              </span>
                            )}
                          </div>

                          <div className="form-group col-lg-12 col-md-12 text-center mt-3">
                            <button
                              className="AllsiteButton mt-2"
                              type="submit"
                              name="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
